import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import CssBaseline from '@mui/material/CssBaseline';
import { THEME_ID, ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'core-js/actual/promise/all-settled';
import 'core-js/actual/promise/with-resolvers';
import { QuestionBuilderProvider } from 'lib-node-question-builder';
import React from 'react';
import ReactDOM from 'react-dom';
import { pdfjs } from 'react-pdf';
import { Provider as ReduxProvider } from 'react-redux';
import WebFont from 'webfontloader';

import { ReadOnlyProvider } from '~/common/components/GlobalLayout/ReadOnlyContext';
import SnackbarContainer from '~/common/components/Snackbar/SnackbarContainer';
import udsTheme from '~/theme';
import muiTheme from '~/theme/mui';

import App from './App';
import { queryClient } from './queryClient';
import { questionBuilderIcons } from './questionBuilderIcons';
import store from './redux';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
const chakraTheme = extendTheme(udsTheme);

WebFont.load({
  google: {
    families: ['Roboto:300,400,500,700,900'],
  },
});

library.add(faInfoCircle);

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={store}>
        <QuestionBuilderProvider
          config={{
            icons: questionBuilderIcons,
            defaultConfigs: {
              useDream: false,
            },
          }}
        >
          <ChakraProvider theme={chakraTheme} resetCSS>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <ThemeProvider
                theme={{
                  [THEME_ID]: muiTheme,
                }}
              >
                <CssBaseline />
                <ReadOnlyProvider>
                  <App />
                </ReadOnlyProvider>
                <SnackbarContainer />
              </ThemeProvider>
            </LocalizationProvider>
          </ChakraProvider>
        </QuestionBuilderProvider>
      </ReduxProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
